var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconrearrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 7,
    r: 1,
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12,
    r: 1,
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 17,
    r: 1,
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 1,
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1,
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 1,
    fill: "#222221"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconrearrange);
export default __webpack_public_path__ + "static/media/icon.rearrange.459542e447c50e19f3b6479757b8e64f.svg";
export { ForwardRef as ReactComponent };